var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgConvert = function SvgConvert(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.5C4 4.22386 4.22386 4 4.5 4H12.2929L15 6.70711V11.995L16 12.9975V6.5V6.29289L15.8536 6.14645L12.8536 3.14645L12.7071 3H12.5H4.5C3.67157 3 3 3.67157 3 4.5V16.5C3 17.3284 3.67157 18 4.5 18H13.01H14.5C15.3284 18 16 17.3284 16 16.5V15.0025L15 16.005V16.5C15 16.7761 14.7761 17 14.5 17H14.0075L13.01 18V17H4.5C4.22386 17 4 16.7761 4 16.5V4.5Z",
    fill: "var(--iconColor, currentColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.5C8 6.67157 8.67157 6 9.5 6H17.7071L21 9.29289V19.5C21 20.3284 20.3284 21 19.5 21H9.5C8.67157 21 8 20.3284 8 19.5V15H13.01V18L17 14L13.01 10V13H8V7.5Z",
    fill: "var(--iconColor, currentColor)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConvert);
export { ForwardRef as ReactComponent };